import { render, staticRenderFns } from "./Users-Employees.vue?vue&type=template&id=1a1c2f06&"
import script from "./Users-Employees.vue?vue&type=script&lang=js&"
export * from "./Users-Employees.vue?vue&type=script&lang=js&"
import style0 from "./Users-Employees.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VIcon,VProgressCircular,VRow})
